<template>
<div>
  <!-- TITLE -->
  <h5 class="mt-2">
    {{ 'CONFIRM_CLOSE_MESSAGE' | translate }}
  </h5>

  <div class="mt-4">

    <!-- REASON SELECT -->
    <div class="form-group" id="policyCaseClose">
      <label id="policyCaseClose-label">{{ 'REASON' | translate }}</label>
      <select v-model="reason" class="form-control" id="policyCaseClose-select">
        <option :value="'closeReason.REASON_1' | translate" id="policyCaseClose-reason-1">{{ 'closeReason.REASON_1' | translate }}</option>
        <option :value="'closeReason.REASON_2' | translate" id="policyCaseClose-reason-2">{{ 'closeReason.REASON_2' | translate }}</option>
        <option :value="'closeReason.REASON_3' | translate" id="policyCaseClose-reason-3">{{ 'closeReason.REASON_3' | translate }}</option>
        <option :value="'closeReason.REASON_4' | translate" id="policyCaseClose-reason-4">{{ 'closeReason.REASON_4' | translate }}</option>
      </select>
    </div>

    <!-- REASON DATE -->
    <div class="form-group" id="policyCaseClose-reson-Date">
      <label id="policyCaseClose-reson-Date-label">{{ 'DATE' | translate }}</label>
      <datepicker name="statusReasonDate"
                  v-model="reasonDate"
                  format="d-M-yyyy"
                  language="nl"
                  input-class="form-control bg-white"
                  id="policyCaseClose-datepicker"
      ></datepicker>
    </div>

    <!-- CONFIRM BUTTON -->
    <button class="btn btn-block btn-success mt-5"
            :disabled="!reason"
            @click="close"
            id="policyCaseClose-confirm-button"
    >{{ 'CLOSE' | translate }}</button>

  </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: { Datepicker },
  data: function () {
    return {
      reason: null,
      reasonDate: new Date()
    }
  },
  computed: {
    preparedStatusReasonAndDate() {
      return this.reasonDate.toISOString().substring(0, 'YYYY-MM-DD'.length) + ' - ' + this.reason;
    }
  },
  methods: {
    close() {
      this.$emit('execute-case-close', this.preparedStatusReasonAndDate);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/case/PolicyCaseClose.vue